export default "__VITE_ASSET__CjiUbiqB__"